import React, { useMemo } from 'react';
import styles from './map-key.module.scss';
import { LocationMarker } from '../../interfaces';
import { useStateValue } from '../state';

interface MapKeyProps {
  markers: LocationMarker[];
}

export const MapKey: React.FC<MapKeyProps> = ({ markers }) => {
  const [state] = useStateValue();
  const keys = useMemo(() => Array.from(new Set(markers.map(marker => marker.type))), [markers]);
  const hiddenClass = state.map.geolocationIntro ? [styles.hidden] : '';

  if (!markers) {
    return null;
  }

  return (
    <div className="map-grid-footer">
      <ul className={`${styles.mapkey} ${hiddenClass}`}>
        {keys.map((key, index) => (
          <li key={index} className={styles.keyitem}>
            <i className={`${styles.keyicon} ${styles[key]}`} />
            {key.replace('-', ' ')}
          </li>
        ))}
      </ul>
    </div>
  );
};
